import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "app/LineDetails/index.scss";
import SkeletonComp from "app/common/skeleton";
import { RootState } from "../reducers/index";
import HeaderSection from "../LineDetails/HeaderWrapper";
import LineListDetails from "app/LineDetails/LineListDetails";
import ChevronLeft from "../../assets/icons/chevron-left-small-black.svg";
// import AddIcon from '../../assets/icons/global-icon-add-device-magenta.svg'
import { useNavigate } from "react-router-dom";
import {
  getLineDetails,
  resetLineDetails,
  unpairLine,
  updateUserInfo,
} from "app/LineDetails/actions";
// import { Button } from '@mui/material'
import "./index.scss";
import { ComponentsContent } from "app/common/NumberCard/NumberCardContent";
import ModalDialog from "app/common/ModalDialog/ModalDialog";
import {
  resetInvitation,
  resetToastMessage,
  sendInvitationInitiated,
  setSharedError,
} from "app/common/NumberCard/action/sharedLinesAction";
import { success } from "app/common/Snackbar/action";
import {
  deactivateLineAction,
  getDeviceListData,
  removeGranteeEmail,
  resetAttempts,
} from "./actions";
import { LineDelveTypes } from "./actions/index.model";
import { clearApiCallStatus } from "app/actions";
import { TextField } from "@mui/material";
import { MyDigitsActionTypes } from "app/LineDetails/actions/index.model";
import { Category } from "app/utils/categories";
import { updateLoader, updateSavingName } from "app/common/NumberCard/action";
import { SavingTypes } from "app/common/NumberCard/action/index.model";
import { DecryptJSON } from "app/utils/crypto";

export interface ModalObject {
  title: string;
  content: string;
  labelClose: string;
  closeAction: () => void;
  closeActionDisable: boolean;
  modalActionDisable: boolean;
  labelAction: string;
  isPending: boolean;
  closeBtnClass: string;
  status?: string;
  actionBtnClass: string;
}

export default function LineDelve(): React.ReactElement {
  // const loading = useSelector((state: RootState) => (state.app.apiCallsStatus[0]?.status === 'final' ? false : true))
  const linesPayload = useSelector((state: RootState) => state.allLines);
  const content = ComponentsContent?.NumberCard;
  let sharedLinesContent = content.sharedLines;
  const [modelObj, setModelObj] = React.useState<ModalObject>(
    {} as ModalObject
  );
  const [contactName, setContactName] = React.useState("");
  const sharedLines = useSelector((state: RootState) => state.shareLine);
  const selectedLine = useSelector(
    (state: RootState) => state.allLines.selectedLineDetails
  );
  const apiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === LineDelveTypes.REMOVE_LINEDELVE_STATUS
    )
  );
  const unpairApiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === MyDigitsActionTypes.UNPAIR_LINE
    )
  );

  const deactivateApiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === LineDelveTypes.DEACTIVATE_LINE
    )
  );
  const lineDeleveDetails = useSelector(
    (state: RootState) => state.lineDelve.lineDelveDetails
  );

  const nameApiStatus = useSelector((state: RootState) =>
    state.app.apiCallsStatus.find(
      (item) => item.module === SavingTypes.UPDATE_SAVING_NAME
    )
  );
  // const noOfAttempts =  useSelector((state:RootState) => state.lineDelve.noOfAttempts);
  const [removeData, setRemoveData] = React.useState<any>(null);
  // const isError = useSelector((state: RootState) => state.numberCard.isError)
  const { firstName, email } = Object(linesPayload.userDetails);
  const [open, setOpen] = React.useState(false);
  const [pairCBData, setPairCBData] = React.useState<any>(null);
  const deviceList = useSelector(
    (state: RootState) => state.lineDelve.deviceList
  );
  const [deactivateLineData, setDeactivateLineData] = React.useState<any>("");
  const initialShareLine = {
    email: "",
    isEmailRequired: false,
    emailDisable: false,
    language: "",
    isAssign: false,
  };
  const [sharedLineObj, setSharedLineObj] = React.useState({
    ...initialShareLine,
  });

  const backActionRef = React.useRef() as React.MutableRefObject<
    HTMLImageElement
  >;
  const [isUserEmailExists, setIsUserEmailExists] = React.useState(false);
  const handleClose = () => {
    dispatch(resetInvitation(null));
    if (linesPayload.selectedLineDetails.categoryID === Category.lineSharedID) {
      setOpen(false);
      dispatch(
        clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
      );
    } else {
      setOpen(false);
      //setModelObj({ ...sharedLinesContent.onAsign });
      dispatch(
        clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
      );
    }
  };

  const clearUnpairData = () => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
    setOpen(false);
    dispatch(clearApiCallStatus({ module: MyDigitsActionTypes.UNPAIR_LINE }));
  };

  React.useEffect(() => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });

    if (nameApiStatus?.noOfAttempts === 3) {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.oops,
        closeAction: closeDialog,
      });
      setOpen(true);
    } else if (nameApiStatus?.status === "error") {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        content:
          "Line name edit was unsuccessful. Please wait a moment and try again.",
        closeAction: closeDialog,
      });
      setOpen(true);
    }
    if (nameApiStatus?.status === "success") {
      closeDialog();
    }
  }, [nameApiStatus?.status, nameApiStatus?.noOfAttempts]);

  const handleCloseBtn = () => {
    setOpen(false);
    dispatch(setSharedError({ error: "" }));
    if (isUserEmailExists) {
      setIsUserEmailExists(false);
    }
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
  };

  const closeDialog = () => {
    if (nameApiStatus?.status === "error") {
      dispatch(updateLoader(false));
    }
    setOpen(false);
    dispatch(clearApiCallStatus({ module: MyDigitsActionTypes.UNPAIR_LINE }));
    dispatch(clearApiCallStatus({ module: SavingTypes.UPDATE_SAVING_NAME }));
  };

  const onAssignClick = () => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
    setRemoveData(null);
    dispatch(resetInvitation(linesPayload.selectedLineDetails.id));
    setOpen(true);
    setModelObj({
      ...sharedLinesContent.onAsign,
      closeAction: handleClose,
    });
  };

  React.useEffect(() => {
    
    handelSharedLineSuccess();
    if (sharedLines?.error) {
      if (sharedLines.error === "ALREADY EMAIL EXISTS") {
        //dispatch(success("ALREADY EMAIL EXISTS"))
        setIsUserEmailExists(true);
        let content = sharedLinesContent.userEXistsError.content;
        content = content.replace("$email", sharedLineObj.email);
        content = content.replace("$deviceName", selectedLine.deviceName);
        setModelObj({
          ...sharedLinesContent.userEXistsError,
          content: content,
        });
        dispatch(resetInvitation(linesPayload.selectedLineDetails.id));
        setSharedLineObj({
          ...sharedLineObj,
          isEmailRequired: false,
        });
      } else {
        setSharedLineObj({
          ...sharedLineObj,
          isEmailRequired: false,
        });
        if (sharedLines.isAssignee) {
          setModelObj({
            ...sharedLinesContent.serverBusy,
            content: sharedLinesContent.serverBusy.content.replace(
              "$email",
              email
            ),
            closeAction: handleClose,
          });
          handleNoOfAttemptsModel(true);
        } else {
          setModelObj({
            ...sharedLinesContent.serverBusy,
            content: sharedLinesContent.serverBusy.content.replace(
              "$email",
              sharedLineObj.email
            ),
            closeAction: handleCloseBtn,
          });
          
          handleNoOfAttemptsModel(false);
        }
      }
    }
  }, [sharedLines]);

  const handelSharedLineSuccess=()=>{
    if (
      sharedLines?.language !== "" &&
      //sharedLines.toastMessage &&
      sharedLines?.error === ""
    ) {
      setSharedLineObj({
        ...sharedLineObj,
        isEmailRequired: false,
        language: sharedLines.language,
      });
      if (sharedLines.msisdn === linesPayload.selectedLineDetails.id) {
        let message;
        if (sharedLines.isAssignee) {
          message = sharedLinesContent.success?.messageAssignee.replace(
            "$deviceName",
            linesPayload.selectedLineDetails.deviceName
          );
        } else {
          message = sharedLinesContent.success?.messageShare.replace(
            "$deviceName",
            linesPayload.selectedLineDetails.deviceName
          );
        }
        dispatch(resetInvitation(null));
        dispatch(success(message));
        dispatch(resetToastMessage());
      }
      setOpen(false);
    }
  }

  const handleNoOfAttemptsModel=(isAssignee:boolean)=>{
   
    if (sharedLines?.noofAttempts === 3) {
      if(!isAssignee){
        setSharedLineObj({
          ...sharedLineObj,
          isEmailRequired: false,
        });
      }      
      setModelObj({
        ...sharedLinesContent.oops,
        closeAction: handleCloseBtn,
      });
    }
  }
  const assignHandler = () => {
    if (
      sharedLines?.noofAttempts === 3 &&
      sharedLines.isAssignee &&
      sharedLines.error
    ) {
      window.open(sharedLinesContent.contactHelp, "_blank");
      dispatch(setSharedError({ error: "" }));
      setOpen(false);
    } else {
      setModelObj({
        ...sharedLinesContent.onAsign,
        closeActionDisable: true,
        modalActionDisable: true,
        isPending: true,
      });
      dispatch(
        sendInvitationInitiated({
          msisdn: linesPayload.selectedLineDetails.id.slice(1),
          granteeEmail: email,
          grantorEmail: email,
          isAssignee: true,
          lineType: linesPayload.selectedLineDetails.lineType,
          MSISDN: linesPayload.selectedLineDetails.id,
          ownerFirstName: firstName,
        })
      );
    }
  };

  const router = useNavigate();
  const dispatch = useDispatch();
  // const onAddUser = (): void => {
  //   console.log("add user");
  // };

  const handleEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const regex = content.Regex.emailValidation;
    const email = e.target.value;
    setSharedLineObj({
      ...sharedLineObj,
      email: email,
    });
    if (email) {
      setModelObj({
        ...modelObj,
        modalActionDisable: !regex.test(email),
      });
    }
  };

  const handleModalAction = () => {
    if (apiStatus?.noOfAttempts === 3) {
      dispatch(resetAttempts());
      window.open(
        ComponentsContent.NumberCard.sharedLines.contactHelp,
        "_blank"
      );
      cleanRemoveData();
    } else {
      const payload = {
        grantee: removeData.granteeEmail,
        id: removeData.msisdn,
      };
      setModelObj({
        ...modelObj,
        isPending: true,
        closeActionDisable: true,
        modalActionDisable: true,
      });
      dispatch(
        removeGranteeEmail({
          ...payload,
          type: linesPayload.selectedLineDetails.categoryID,
        })
      );
    }
  };

  const onRemoveClick = (data: any) => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
    const selectedRow = lineDeleveDetails.userEmails.find(
      (obj) => obj.grantee === data.granteeID
    );
    if (selectedRow) {
      setRemoveData(selectedRow ? selectedRow : null);
    }
    var contentText = "";
    if (email === selectedRow?.granteeEmail) {
      contentText =
        "You are about to remove yourself from this line. You will be not be able to use this line in DIGITS until you add yourself again.";
    } else {
      contentText = `You are about to remove ${selectedRow?.granteeEmail} from the line ${selectedLine.deviceName}. They will be unable to use this line unless you reinvite them.`;
    }

    if (selectedLine.categoryID === Category.lineSharedID) {
      if (email === selectedRow?.granteeEmail) {
        contentText = `You are about to remove yourself from the line ${selectedLine.deviceName}. Are you sure you want to leave?`;
      } else {
        contentText = `You are about to remove ${selectedRow?.granteeEmail} from the line ${selectedLine.deviceName}. They will be unable to use this line unless you reinvite them.`;
      }
      setModelObj({
        ...ComponentsContent.LineDelve.removeGuest,
        title: `Leave this line?`,
        content: contentText,
        closeAction: handleClose,
        labelClose: "CANCEL",
        labelAction: "LEAVE",
      });
    } else {
      setModelObj({
        ...ComponentsContent.LineDelve.removeGuest,
        title:
          email === selectedRow?.granteeEmail
            ? "Remove yourself?"
            : "Remove this user?",
        content: contentText,
        closeAction: handleClose,
        labelClose: "CANCEL",
        labelAction:
          email === selectedRow?.granteeEmail
            ? "REMOVE YOURSELF"
            : "REMOVE GUEST",
      });
    }

    setOpen(true);
  };

  React.useEffect(() => {
    if (email === "") {
      const userDetails = DecryptJSON(sessionStorage.getItem("userDetails"));
      dispatch(updateUserInfo(userDetails));
    }
  }, []);

  React.useEffect(() => {
    if (lineDeleveDetails?.lines?.length > 0) {
      dispatch(
        getDeviceListData({ msisdn: linesPayload.selectedLineDetails.id })
      );
      // dispatch(getPrimaryDevice({ imsi: linesPayload.selectedLineDetails.imsi }))
    }
  }, [lineDeleveDetails.lines]);

  const backToHome = () => {
    router("/");
  };

  const removeCB = () => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });

    if (selectedLine.categoryID === Category.lineSharedID) {
      setModelObj({
        ...ComponentsContent.LineDelve.removeGuest,
        title: `Leave this line?`,
        content: `You are about to remove yourself from the line ${selectedLine.deviceName}. Are you sure you want to leave?`,
        closeAction: handleClose,
        labelClose: "CANCEL",
        labelAction: "LEAVE",
      });
    } else {
      setModelObj({
        ...ComponentsContent.LineDelve.removeGuest,
        title: `Remove yourself?`,
        content: `You are about to remove yourself from this line. You will be not be able to use this line in DIGITS until you add yourself again.`,
        closeAction: handleClose,
        labelClose: "CANCEL",
        labelAction: "REMOVE YOURSELF",
      });
    }
    // const devicename = linesPayload.selectedLineDetails.deviceName;

    setRemoveData(null);
    setOpen(true);
  };

  const shareLineHandler = () => {
    if (isUserEmailExists) {
      setOpen(false);
      setIsUserEmailExists(false);
    } else {
      if (sharedLines?.noofAttempts === 3) {
        window.open(sharedLinesContent.contactHelp, "_blank");
        handleClose();
      } else {
        const isAssign = sharedLineObj.isAssign;
        setSharedLineObj({
          ...sharedLineObj,
          emailDisable: true,
          isEmailRequired: false,
        });

        setModelObj({
          ...modelObj,
          closeActionDisable: true,
          modalActionDisable: true,
          isPending: true,
        });

        dispatch(
          sendInvitationInitiated({
            msisdn: linesPayload.selectedLineDetails.id.slice(1),
            granteeEmail: isAssign ? email : sharedLineObj.email,
            grantorEmail: email,
            lineType: linesPayload.selectedLineDetails.lineType,
            isAssignee: isAssign,
            MSISDN: linesPayload.selectedLineDetails.id,
            ownerFirstName: firstName,
          })
        );
        // setTimeout(function () {
        //   if (sharedLines.language === "" && sharedLines.toastMessage) {
        //     dispatch(setLongRunningQuery());
        //     handleCloseBtn();
        //   }
        // }, 3000);
      }
    }
  };

  const closeDeactivate = () => {
    setOpen(false);
    dispatch(clearApiCallStatus({ module: LineDelveTypes.DEACTIVATE_LINE }));
  };

  const dialogAction = (title: string) => {
    const categoryID = linesPayload.selectedLineDetails.categoryID;
    if (nameApiStatus?.status === "error") {
      return saveCB;
    }
    if (
      deactivateApiStatus?.status === "error" ||
      title === "Deactivate this line?" ||
      title === "Unable to deactivate line"
    ) {
      return deactivateLine;
    }
    if (
      unpairApiStatus?.status === "error" ||
      title === "Unpair Device" ||
      title === "Unable to unpair phone number"
    ) {
      return unpairHandler;
    }
    if (removeData) {
      return handleModalAction;
    }
    if (
      (categoryID === Category.lineSharedID ||
        categoryID === Category.assignedID) &&
      (title === "Remove yourself?" ||
        title === "Leave this line?" ||
        apiStatus?.status === "error")
    ) {
      return removeHandler;
    }
    if (
      title?.indexOf("Share line") > -1 ||
      title === "User already exists." ||
      sharedLines.error
    ) {
      return shareLineHandler;
    }
    if (title === "Assigning line to yourself?") {
      return assignHandler;
    }

    return assignHandler;
  };

  React.useEffect(() => {
    if (deactivateApiStatus?.status === "success") {
      setOpen(false);
    }
    if (deactivateApiStatus?.status === "error") {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        title: "Unable to deactivate line",
        content:
          "Deactivating line was unsuccessful. Please wait a moment and try again.",
        closeAction: closeDeactivate,
      });

      if (deactivateApiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          closeAction: closeDeactivate,
        });
      }
    }
  }, [deactivateApiStatus?.status, deactivateApiStatus?.noOfAttempts]);

  React.useEffect(() => {
    if (apiStatus?.status === "success") {
      setOpen(false);
      const categoryID = linesPayload.selectedLineDetails.categoryID;
      dispatch(
        clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
      );
      if (
        categoryID !== Category.assignedID &&
        categoryID !== Category.unAssignedID
      ) {
        if (!removeData || categoryID === Category.lineSharedID) {
          backToHome();
          dispatch(resetLineDetails());
          dispatch(getLineDetails());
        }
      }
    }

    if (apiStatus?.status === "error") {
      var busyContent =
        "You were unable to remove yourself from this line. Please wait a moment and try again.";
      if (removeData && email !== removeData?.granteeEmail) {
        busyContent =
          "You were unable to remove this user from this line. Please wait a moment and try again.";
      }
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        content: busyContent,
        closeAction: cleanRemoveData,
      });

      if (apiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          closeAction: cleanRemoveData,
        });
      }

      setOpen(true);
    }
  }, [apiStatus?.status, apiStatus?.noOfAttempts]);

  const deactivateLine = () => {
    if (deactivateApiStatus?.noOfAttempts === 3) {
      window.open(
        ComponentsContent.NumberCard.sharedLines.contactHelp,
        "_blank"
      );
      closeDeactivate();
    } else {
      setModelObj({
        ...modelObj,
        status: "Deactivating…",
        isPending: true,
      });
      dispatch(
        deactivateLineAction({
          id: deactivateLineData.id,
          deviceId: deactivateLineData.deviceId,
        })
      );
    }
  };

  const deactivateCB = (deviceId: string, id: string) => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
    const line = deviceList.find((item) => item.deviceId === deviceId);
    setDeactivateLineData({ ...line, id });

    var content = ComponentsContent.NumberCard.sharedLines.deactivateLine.content.replace(
      "$deviceName",
      line.deviceName
    );
    content = content.replace("$primaryDevice", selectedLine.deviceName);
    setModelObj({
      ...ComponentsContent.NumberCard.sharedLines.deactivateLine,
      content: content,
      closeAction: closeDeactivate,
    });
    setOpen(true);
  };

  const cleanRemoveData = () => {
    setOpen(false);
    dispatch(
      clearApiCallStatus({ module: LineDelveTypes.REMOVE_LINEDELVE_STATUS })
    );
  };

  const removeHandler = () => {
    if (apiStatus?.noOfAttempts === 3) {
      dispatch(resetAttempts());
      window.open(
        ComponentsContent.NumberCard.sharedLines.contactHelp,
        "_blank"
      );
      cleanRemoveData();
    } else {
      setModelObj({
        ...modelObj,
        isPending: true,
        closeActionDisable: true,
        modalActionDisable: true,
      });
      dispatch(
        removeGranteeEmail({
          id: linesPayload.selectedLineDetails.id,
          type: linesPayload.selectedLineDetails.categoryID,
        })
      );
    }
  };

  const unpairHandler = () => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
    const contactHelp = ComponentsContent.NumberCard.sharedLines.contactHelp;
    if (unpairApiStatus?.noOfAttempts === 3) {
      window.open(contactHelp, "_blank");
      closeDialog();
    } else {
      setModelObj({
        ...modelObj,
        status: "Unpairing...",
        isPending: true,
      });
      dispatch(unpairLine({ msisdn: pairCBData.id, type: "delveDetails" }));
    }
  };
  React.useEffect(() => {
    if (unpairApiStatus?.status === "success") {
      clearUnpairData();
    }
    if (unpairApiStatus?.status === "error") {
      setModelObj({
        ...ComponentsContent.NumberCard.sharedLines.serverBusy,
        title: "Unable to unpair phone number",
        status: "",
        content:
          "There was an issue unpairing your phone number. Would you like to try again?",
        closeAction: clearUnpairData,
      });

      if (unpairApiStatus?.noOfAttempts === 3) {
        setModelObj({
          ...ComponentsContent.NumberCard.sharedLines.oops,
          closeAction: clearUnpairData,
        });
      }

      setOpen(true);
    }
  }, [unpairApiStatus?.noOfAttempts, unpairApiStatus?.status]);

  const unpairCB = (data: any) => {
    setSharedLineObj({
      ...sharedLineObj,
      isEmailRequired: false,
    });
    setPairCBData(data);
    setModelObj({
      ...ComponentsContent.NumberCard.sharedLines.unpairLine,
      content: `${data.ganntee} will no longer be paired with ${selectedLine.deviceName} - ${selectedLine.id}.`,
      closeAction: closeDialog,
    });

    setOpen(true);
  };

  const saveCB = (name: string) => {
    if (nameApiStatus?.noOfAttempts === 3) {
      window.open(sharedLinesContent.contactHelp, "_blank");
      closeDialog();
    } else {
      if (nameApiStatus?.status === "error") {
        setModelObj({
          ...modelObj,
          status: "updating...",
          isPending: true,
        });
        dispatch(
          updateSavingName({
            id: selectedLine.id,
            givenName: contactName,
            categoryID: selectedLine.categoryID,
          })
        );
      } else {
        setContactName(name);
        dispatch(
          updateSavingName({
            id: selectedLine.id,
            givenName: name,
            categoryID: selectedLine.categoryID,
          })
        );
      }
    }
  };

  const handleKeyUp = (event: any, ele: any) => {
    if (event.keyCode === 13) {
      ele.current.click();
    }
  };

  //const [timestamp,setTimeStamp]=React.useState( new Date().getMilliseconds())

  const shareLineCB = () => {
    // setTimeStamp( new Date().getMilliseconds());
    setRemoveData(null);
    dispatch(resetInvitation(linesPayload.selectedLineDetails.id));
    setSharedLineObj({
      ...sharedLineObj,
      email: "",
      isEmailRequired: true,
      emailDisable: false,
      isAssign: false,
    });
    setModelObj({
      ...sharedLinesContent.invitaion,
      title: sharedLinesContent.invitaion.title.replace(
        "$DeviceName",
        linesPayload.selectedLineDetails.deviceName
      ),
      closeAction: () => setOpen(false),
    });
    setOpen(true);
  };

  return (
    <React.Fragment>
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid className="welcomeBar" container spacing={2}>
            {/* <span> */}
            <img
              tabIndex={0}
              onKeyUp={(event) => handleKeyUp(event, backActionRef)}
              ref={backActionRef}
              src={ChevronLeft}
              alt={"ChevronLeft"}
              className="chevron-left"
              onClick={backToHome}
            />
            {/* </span> */}
            <HeaderSection
              // onAddUser={onAddUser}
              firstName={firstName}
              email={email}
              loading={linesPayload.loading}
            />

            <Grid item container>
              <SkeletonComp
                loadData={{
                  loading: linesPayload.loading,
                  height: 50,
                  width: 283,
                  className: "smyDigits",
                }}
              >
                <div className="myDigits">
                  <span className="digitcount" tabIndex={0}>
                    My DIGITS
                  </span>
                </div>
              </SkeletonComp>
            </Grid>
            <LineListDetails
              shareLineCB={shareLineCB}
              onRemoveCB={onRemoveClick}
              assignCB={onAssignClick}
              removeSelfCB={removeCB}
              unpairCB={unpairCB}
              deactivateCB={deactivateCB}
              onSaveCB={saveCB}
            ></LineListDetails>
          </Grid>
        </Box>
      </Container>
      <ModalDialog
        openModal={open}
        modelObj={modelObj}
        dialogAction={dialogAction(modelObj.title)}
        // uniquId={"linesListDelve"+timestamp}
      >
        {sharedLineObj?.isEmailRequired && (
          <TextField
            size="small"
            id={`email-${linesPayload.selectedLineDetails.id}`}
            variant="outlined"
            onChange={handleEmail}
            className="emailAddress"
            disabled={sharedLineObj.emailDisable}
            value={sharedLineObj.email}
            tabIndex={0}
            fullWidth
            placeholder="Email address"
          />
        )}
      </ModalDialog>
    </React.Fragment>
  );
}
